import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';


@Component({
})
export default class SBPopup extends Mixins(SBComponentVue) {

    @Prop({
        type: Boolean,
        default: false,
    })
    public value!: boolean;

    @Emit("input")
    public input(val: boolean) {
    }

}
